import React from 'react';
import './App.css';
import './styles/design-system.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// New Redesigned Pages
import HomeNew from './pages/HomeNew';
import WorkflowPage from './pages/WorkflowPage';
import WorkflowSimulatorPage from './pages/WorkflowSimulatorPage';
import AgentRegistry from './pages/AgentRegistry';
import AgentDetailNew from './pages/AgentDetailNew';
import DevelopersHub from './pages/DevelopersHub';
import PlatformEconomics from './pages/PlatformEconomics';
import ResearchPage, { ResearchHub } from './pages/ResearchPage';
import RequestDemo from './pages/RequestDemo';

// Preserved Pages (Admin & User Auth)
import AdminLeads from './pages/EnhancedAdminLeads';
import AdminLogin from './pages/AdminLogin';
import UserSignup from './pages/UserSignup';
import UserLogin from './pages/UserLogin';
import UserDashboard from './pages/UserDashboard';
import UserSettings from './pages/UserSettings';
import ForgotPassword from './pages/ForgotPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Components
import HeaderNew from './components/HeaderNew';
import FooterNew from './components/FooterNew';
import PageTracker from './components/PageTracker';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { UserAuthProvider } from './context/UserAuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { UserProtectedRoute } from './components/UserProtectedRoute';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <UserAuthProvider>
              <PageTracker />
              <HeaderNew />
              <Routes>
                {/* New Redesigned Routes */}
                <Route path="/" element={<HomeNew />} />
                
                {/* Workflow Routes - Step 5 */}
                <Route path="/workflows/:workflowId" element={<WorkflowPage />} />
                <Route path="/workflow-simulator" element={<WorkflowSimulatorPage />} />
                
                {/* Agent Routes - Steps 6 & 7 */}
                <Route path="/agents" element={<AgentRegistry />} />
                <Route path="/agents/:agentId" element={<AgentDetailNew />} />
                
                {/* Developer Routes - Step 8 */}
                <Route path="/developers" element={<DevelopersHub />} />
                <Route path="/developers/apis" element={<DevelopersHub />} />
                <Route path="/developers/agent-sdk" element={<DevelopersHub />} />
                <Route path="/developers/publish-agent" element={<DevelopersHub />} />
                
                {/* Platform Economics - Step 9 */}
                <Route path="/platform-economics" element={<PlatformEconomics />} />
                
                {/* Research Routes - Step 10 */}
                <Route path="/research" element={<ResearchHub />} />
                <Route path="/research/:researchId" element={<ResearchPage />} />
                
                {/* Request Demo - Step 11 */}
                <Route path="/request-demo" element={<RequestDemo />} />
                
                {/* Preserved Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route 
                  path="/admin/leads" 
                  element={
                    <ProtectedRoute>
                      <AdminLeads />
                    </ProtectedRoute>
                  } 
                />
                
                {/* Preserved User Routes */}
                <Route path="/user/signup" element={<UserSignup />} />
                <Route path="/user/login" element={<UserLogin />} />
                <Route path="/user/forgot-password" element={<ForgotPassword />} />
                <Route 
                  path="/user/dashboard" 
                  element={
                    <UserProtectedRoute>
                      <UserDashboard />
                    </UserProtectedRoute>
                  } 
                />
                <Route 
                  path="/user/settings" 
                  element={
                    <UserProtectedRoute>
                      <UserSettings />
                    </UserProtectedRoute>
                  } 
                />
                
                {/* Static Pages */}
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
              </Routes>
              <FooterNew />
              <Toaster position="top-right" theme="light" />
            </UserAuthProvider>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
